import { sortNewest } from "../lib/format.js";
import { ActivityTable } from "../components/crmTables.jsx";
import { Topbar } from "../components/ui.jsx";

export function ActivitiesView({ activities, customers, users, activityCustomFields = [], openActivity, openCustomer, openEmployee, openCall, openVisit, openMessage }) {
  return (
    <>
      <Topbar title="Calls & Visits" subtitle="Log customer communication and field work with basic GPS verification.">
        <button className="secondary-btn" onClick={openActivity}>
          Log Activity
        </button>
      </Topbar>
      <section className="panel">
        <ActivityTable
          activities={[...activities].sort(sortNewest)}
          customers={customers}
          users={users}
          activityCustomFields={activityCustomFields}
          openCustomer={openCustomer}
          openEmployee={openEmployee}
          openCall={openCall}
          openVisit={openVisit}
          openMessage={openMessage}
        />
      </section>
    </>
  );
}
